import React from 'react';
import ContextsSwitcher from '../ContextsSwitcher';

import './ResultToolbarHeatmapView.scss';

export default function ResultToolbarHeatmapView(props) {
  return (
    <section className="hide-for-heatmap-in-fullscreen">
      <ContextsSwitcher {...props} />
    </section>
  );
}
